import { render, staticRenderFns } from "./RankingChart.vue?vue&type=template&id=cb002afa"
import script from "./RankingChart.vue?vue&type=script&lang=js"
export * from "./RankingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports